import React from "react";
import { useTranslation } from "react-i18next";
import MoneyDisplay from "../../../common/components/MoneyDisplay";
import styled from "styled-components";
import {
  BoldParagraph,
  H1,
} from "../../../common/styled-components/typography";

const PriceWithoutStyle = styled.span``
const PriceWithStyle = styled(H1)`
    margin: 0 10px 0 0 !important;
    line-height: 0.9;
`

const PricePrecisionWithStyle = styled(BoldParagraph)`
    margin: 0;
`

const PricePrecisionWithoutStyle = styled.span``

interface OfferPriceProps {
    price: number;
    tax?: number|null;
    isTaxIncluded?: boolean|null;
    withStyle?: boolean;
    isFirstLetterCapital?: boolean;
}

const OfferPrice = ({
    price,
    tax = null,
    isTaxIncluded = null,
    withStyle = true,
    isFirstLetterCapital = true,
}: OfferPriceProps) => {
    const Price = withStyle ? PriceWithStyle : PriceWithoutStyle;
    const PricePrecision = withStyle ? PricePrecisionWithStyle : PricePrecisionWithoutStyle;
    const { t } = useTranslation();
    const displayPrice = tax !== null && !isTaxIncluded ? price - tax : price;
    if (displayPrice === 0.0) {
        return isFirstLetterCapital ? <>{t("free_first_letter_capital")}</> : <>{t("free")}</>;
    }

    if (tax === null && isTaxIncluded === null) {
        return <Price><MoneyDisplay amount={displayPrice} /></Price>;
    }

    if (tax === 0.0) {
        return <>
            <Price><MoneyDisplay amount={displayPrice} /></Price>
            <PricePrecision>({t("noTaxApplicable")})</PricePrecision>
        </>;
    }

    return <>
        <Price><MoneyDisplay amount={displayPrice} /></Price>
        <PricePrecision>({isTaxIncluded ? t("taxesIncluded") :t("plusTaxes") })</PricePrecision>
    </>;
}

export default OfferPrice;